import React from 'react';
import PropTypes from 'prop-types';
import BrandwireCommentItem from './BrandwireCommentItem';

class BrandwireComments extends React.PureComponent {
  getBrandwireComments() {
    const { commentsData } = this.props;
    let html = '';
    if (commentsData && commentsData.length > 0) {
      html = commentsData.map(obj => (
        <React.Fragment key={obj._id}>
          <BrandwireCommentItem
            commentsData={obj}
            isWapView={this.props.isWapView}
          />
        </React.Fragment>
      ));
    }

    return html;
  }

  render() {
    return this.getBrandwireComments();
  }
}

BrandwireComments.propTypes = {
  commentsData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isWapView: PropTypes.bool,
};

BrandwireComments.defaultProps = {
  isWapView: false,
};

export default BrandwireComments;
